import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import './Navigation.css';

/**
 * SEO-optimized navigation component
 */
export function Navigation() {
  const location = useLocation();
  const { mode, toggleTheme } = useTheme();
  const isActive = (path: string) => location.pathname === path;

  // Label mappings for different pages
  const defaultLabels = {
    search: 'Search',
    vendors: 'Vendors',
    supplies: 'Supplies',
    calculator: 'Calculator',
    exclusiveDeals: 'Exclusive Deals',
  };

  const researchToolsLabels = {
    search: 'Platform Overview',
    vendors: 'Vendor Insights',
    supplies: 'Market Categories',
    calculator: 'Research Tools',
    exclusiveDeals: 'Alerts & Updates',
  };

  // Use research-tools labels when on /research-tools page, otherwise use default labels
  const labels = location.pathname === '/research-tools' ? researchToolsLabels : defaultLabels;

  return (
    <nav className="navigation" aria-label="Main navigation">
      <div className="navigation-container">
        <Link to="/" className="navigation-logo" aria-label="Peptide Finder Home">
          Peptide Finder
        </Link>
        <ul className="navigation-menu" role="menubar">
          <li role="none">
            <Link
              to="/"
              className={`navigation-link ${isActive('/') ? 'navigation-link-active' : ''}`}
              role="menuitem"
              aria-current={isActive('/') ? 'page' : undefined}
            >
              {labels.search}
            </Link>
          </li>
          <li role="none">
            <Link
              to="/vendors"
              className={`navigation-link ${isActive('/vendors') ? 'navigation-link-active' : ''}`}
              role="menuitem"
              aria-current={isActive('/vendors') ? 'page' : undefined}
            >
              {labels.vendors}
            </Link>
          </li>
          <li role="none">
            <Link
              to="/supplies"
              className={`navigation-link ${isActive('/supplies') ? 'navigation-link-active' : ''}`}
              role="menuitem"
              aria-current={isActive('/supplies') ? 'page' : undefined}
            >
              {labels.supplies}
            </Link>
          </li>
          <li role="none">
            <Link
              to="/calculator"
              className={`navigation-link ${isActive('/calculator') ? 'navigation-link-active' : ''}`}
              role="menuitem"
              aria-current={isActive('/calculator') ? 'page' : undefined}
            >
              {labels.calculator}
            </Link>
          </li>
          <li role="none">
            <Link
              to="/exclusive-deals"
              className={`navigation-link ${isActive('/exclusive-deals') ? 'navigation-link-active' : ''}`}
              role="menuitem"
              aria-current={isActive('/exclusive-deals') ? 'page' : undefined}
            >
              {labels.exclusiveDeals}
            </Link>
          </li>
        </ul>
        <div className="navigation-right">
          <button
            type="button"
            onClick={toggleTheme}
            className="theme-toggle"
            aria-label={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}
            title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}
          >
            {mode === 'light' ? (
              <span className="theme-toggle-icon" aria-hidden="true">🌙</span>
            ) : (
              <span className="theme-toggle-icon" aria-hidden="true">☀️</span>
            )}
          </button>
          <div className="navigation-footer-links">
            <Link to="/privacy" className="navigation-footer-link">
              Privacy
            </Link>
            <span className="navigation-footer-separator">•</span>
            <Link to="/terms" className="navigation-footer-link">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

